module.exports = __webpack_public_path__ + "img/topcart.ce2d8bfd.png";